import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConnectButton } from '@rainbow-me/rainbowkit';

const NAV = [
  { to: '/dashboard/overview', key: 'dashboard.nav.overview', icon: 'fa-gauge-high' },
  { to: '/dashboard/deposits', key: 'dashboard.nav.deposits', icon: 'fa-layer-group' },
  { to: '/dashboard/new', key: 'dashboard.nav.new', icon: 'fa-plus' },
  { to: '/dashboard/referrals', key: 'dashboard.nav.referrals', icon: 'fa-user-group' },
  { to: '/dashboard/activity', key: 'dashboard.nav.activity', icon: 'fa-clock-rotate-left' },
];

const DashboardNav = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Desktop top-bar */}
      <header className="db-topbar">
        <div className="container">
          <div className="db-topbar__inner">
            <Link to="/" className="db-topbar__logo" aria-label="Home">
              <span className="db-topbar__logo-mark" aria-hidden="true">
                <svg viewBox="0 0 32 32" width="26" height="26">
                  <defs>
                    <linearGradient id="dbNavLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#FFD56B" />
                      <stop offset="100%" stopColor="#E0A820" />
                    </linearGradient>
                  </defs>
                  <polygon
                    points="16,2 28,9 28,23 16,30 4,23 4,9"
                    fill="none"
                    stroke="url(#dbNavLogoGrad)"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                  <text
                    x="16"
                    y="22"
                    textAnchor="middle"
                    fontFamily="Inter, sans-serif"
                    fontSize="16"
                    fontWeight="900"
                    fill="url(#dbNavLogoGrad)"
                  >
                    S
                  </text>
                </svg>
              </span>
              <span className="db-topbar__logo-text">SCROOGE</span>
            </Link>

            <nav className="db-topbar__nav">
              {NAV.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `db-topbar__link${isActive ? ' is-active' : ''}${
                      item.to === '/dashboard/new' ? ' db-topbar__link--cta' : ''
                    }`
                  }
                >
                  <i className={`fas ${item.icon}`} aria-hidden="true" />
                  <span>{t(item.key)}</span>
                </NavLink>
              ))}
            </nav>

            <div className="db-topbar__right">
              <Link to="/" className="db-topbar__home" aria-label={t('dashboard.nav.backHome')}>
                <i className="fas fa-house" />
              </Link>
              <ConnectButton
                showBalance={false}
                chainStatus="icon"
                accountStatus={{ smallScreen: 'avatar', largeScreen: 'address' }}
              />
            </div>
          </div>
        </div>
      </header>

      {/* Mobile bottom tab-bar */}
      <nav className="db-tabbar" aria-label="Dashboard navigation">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `db-tabbar__item${isActive ? ' is-active' : ''}${
                item.to === '/dashboard/new' ? ' db-tabbar__item--cta' : ''
              }`
            }
          >
            <i className={`fas ${item.icon}`} aria-hidden="true" />
            <span>{t(item.key)}</span>
          </NavLink>
        ))}
      </nav>
    </>
  );
};

export default DashboardNav;
